import { useMemo } from 'react'

import { y } from '@circlefin/form'
import { createFormDropdown } from '@circlefin/form/Form.Dropdown'
import { UserRoleGroupType } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import type { DropdownProps } from '@circlefin/components/lib/Dropdown'

export const UserRolesSchema = y
  .string()
  .oneOf(Object.values(UserRoleGroupType))
  .required()

export type UserRolesFormValues = y.InferType<typeof UserRolesSchema>

export type UserRolesProps = Omit<
  DropdownProps<UserRoleGroupType>,
  'name' | 'children' | 'items'
>

const Dropdown = createFormDropdown()

export const UserRoles: React.FC<UserRolesProps> = ({
  className,
  ...props
}) => {
  const { t } = useTranslation('settings')

  const items = useMemo(
    () =>
      [
        UserRoleGroupType.ADMINISTRATOR,
        UserRoleGroupType.AGENT,
        UserRoleGroupType.VIEWER,
      ].map((type) => ({
        label: t(`personalInfo.roleType.${type}`),
        value: type,
      })),
    [t],
  )

  return <Dropdown {...props} items={items} name="userRole" />
}
